import React from "react"
import { motion } from "framer-motion"
import { Star, Quote } from "lucide-react"

const testimonials = [
  {
    name: "Ayesha Khan",
    role: "Homeowner",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80",
    quote: "Finding a reliable plumber used to be a nightmare. Hazer connected me with a verified professional within minutes. Highly recommended!",
    rating: 5
  },
  {
    name: "Ahmed Ali",
    role: "Property Manager",
    image: "https://images.unsplash.com/photo-1599566150163-29194dcaad36?w=400&q=80",
    quote: "We use Hazer for all our property maintenance needs. The transparency in pricing and quality of service is unmatched.",
    rating: 5
  },
  {
    name: "Sarah Qureshi",
    role: "Interior Designer",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80",
    quote: "As an interior designer, I constantly need skilled carpenters and painters. This platform is my go-to for finding top talent quickly.",
    rating: 4
  }
]

export default function Reviews() {
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.15 }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
  }

  return (
    <section className="py-24 bg-[#F8FAFC] relative overflow-hidden">
      {/* Background blobs */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-primary/5 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/3"></div>
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-brand-secondary/5 rounded-full blur-[100px] translate-y-1/2 -translate-x-1/3"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-16 space-y-4">
          <div className="inline-flex items-center justify-center p-2 bg-brand-primary/10 rounded-full mb-2">
            <Star className="w-5 h-5 text-brand-primary fill-brand-primary" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-brand-text tracking-tight">Don't just take our word for it</h2>
          <p className="text-lg md:text-xl text-brand-muted max-w-2xl mx-auto">
            See what thousands of satisfied customers have to say about their experience with our professionals.
          </p>
        </div>

        <motion.div 
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          className="grid md:grid-cols-3 gap-8"
        >
          {testimonials.map((testimonial, idx) => (
            <motion.div key={idx} variants={itemVariants} className="bg-white p-8 rounded-[24px] shadow-soft hover:shadow-premium transition-all duration-500 hover:-translate-y-2 border border-slate-100 relative group">
              <Quote className="absolute top-8 right-8 w-12 h-12 text-brand-background group-hover:text-brand-primary/10 transition-colors duration-500" />
              
              <div className="flex gap-1 text-yellow-400 mb-6">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className={`w-5 h-5 ${i < testimonial.rating ? "fill-current" : "fill-slate-200 text-slate-200"}`} />
                ))}
              </div>
              
              <p className="text-brand-text text-lg leading-relaxed mb-8 italic">
                "{testimonial.quote}"
              </p>
              
              <div className="flex items-center gap-4 mt-auto">
                <img src={testimonial.image} alt={testimonial.name} className="w-14 h-14 rounded-full object-cover border-2 border-slate-50 shadow-sm" />
                <div>
                  <h4 className="font-bold text-brand-text">{testimonial.name}</h4>
                  <p className="text-sm font-medium text-brand-muted">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}
